/* TERMIN STORNIEREN MIT WARTEGRUND FÜRS GBGS (.459).
   ORIGINALTEXT MARVIN (22.10.2026)
     „wenn ein Termin storniert wird, dass dann auch das Pop-up quasi das
      gleiche kommt, ausgewählt wird, okay, hier, wieso, weshalb, warum, Storno,
      ein kurzer Kommentar geschrieben wird, in Klammern da steht, Achtung, auf
      die Formulierung für die Telekom sichtbar, um das nochmal hervorzuheben,
      dass da saubere Sätze stehen, und dann bestätigen, und dann kann das
      System loslaufen und die richtigen Einträge mit der richtigen Wartegrund
      entsprechend setzen."
   Oben der Grund für die Akte (intern), darunter, wenn der Auftrag im GBGS
   steht und Einblasen/Spleißen abgesagt werden, der Wartegrund: Grund aus der
   Liste („Häufig" oben), Wiedervorlage und der Kommentar für die Telekom mit
   Vorschau, so wie er im Portal steht. Der Roboter sagt danach im IBT den
   Gf-AP am Grundstück ab und setzt den Wartegrund am Gf-AP; im Bulk bleibt
   der Termin stehen und nur der Wartegrund kommt dazu. */
import { useEffect, useState } from 'react';
import { api } from '../api.ts';
import { Dialog, Fehlerkasten, type Fehlerlage } from './Formular.tsx';
import { FreitextBausteine, GrundOptionen, freitextVorschlaege, WvHinweis, wvZielIso } from './wartegrundHaeufig.tsx';
import { vorlageFuellen } from '../seiten/Gbgs.tsx';

export interface GbgsStornoAngabe { hashtag?: string; kommentar?: string; wiedervorlage?: string | null; ohne?: boolean }

const deDatum = (iso: string) => iso ? iso.split('-').reverse().join('.') : '';

export default function TerminStornoFenster({
  titel, untertitel, auftragId, arten, erklaerung, laeuft, fehler, zu, fertig,
}: {
  titel: string; untertitel?: string; auftragId: string; arten: string[]; erklaerung?: string;
  laeuft: boolean; fehler: Fehlerlage | null; zu: () => void;
  fertig: (grund: string, gbgs: GbgsStornoAngabe | null) => void;
}) {
  const [grund, setGrund] = useState('');
  const [info, setInfo] = useState<any>(null);
  const [hashtag, setHashtag] = useState('');
  const [kommentar, setKommentar] = useState('');
  const [wv, setWv] = useState('');
  const [ohne, setOhne] = useState(false);
  const montage = arten.some((a) => a === 'EB' || a === 'SP');
  useEffect(() => {
    if (!montage) return;
    api.gbgsStornoInfo(auftragId).then((r: any) => { setInfo(r); setWv(wvZielIso()); }).catch(() => setInfo(null));
  }, [auftragId, montage]);

  const imGbgs = montage && !!info?.modus;
  const bulk = info?.modus === 'BULK';
  const liste: 'STANDARD' | 'BFO' = info?.modus === 'STANDARD' ? 'STANDARD' : 'BFO';
  const gruende: any[] = info?.gruende ?? [];
  const gewaehlt = gruende.find((w) => w.hashtag === hashtag);
  const vorlagen: any[] = info?.vorlagen ?? [];
  const vorlage = vorlagen.find((v) => v.hashtag === hashtag) ?? vorlagen.find((v) => !v.hashtag) ?? null;
  const jetzt = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date());
  const vorschau = gewaehlt && vorlage ? vorlageFuellen(vorlage.text, {
    datum: jetzt, uhrzeit: '', bearbeiter: '', firma: '', grund: bulk ? gewaehlt.kategorie_text : `#${gewaehlt.hashtag}# ${gewaehlt.grund_text}`,
    hashtag: `#${gewaehlt.hashtag}#`, wiedervorlage: deDatum(wv), adresse: '', kls: String(info?.kls_id ?? ''), freitext: kommentar.trim(),
  }) : '';
  const kommentarOk = kommentar.trim().length >= 15;
  const gbgsOk = !imGbgs || ohne || (!!hashtag && kommentarOk && !!wv);
  const bereit = grund.trim().length >= 3 && gbgsOk;

  return (
    <Dialog titel={titel} untertitel={untertitel} laeuft={laeuft} zu={zu} breite={imGbgs ? 680 : 520}>
      <Fehlerkasten lage={fehler} />
      {erklaerung && <p className="klein leise">{erklaerung}</p>}
      <div className="feld"><label>Grund (intern, für die Akte)</label>
        <textarea rows={2} value={grund} onChange={(e) => setGrund(e.target.value)} />
      </div>

      {imGbgs && (
        <div className="karte" style={{ marginTop: 10 }}>
          <h3>Wartegrund im GBGS{bulk ? ' (Bulk: der Termin bleibt im Portal stehen)' : ' (IBT: erst Absage am Grundstück, dann Wartegrund am Gf-AP)'}</h3>
          <div className="leib">
            <label className="klein" style={{ display: 'block', marginBottom: 8 }}>
              <input type="checkbox" checked={ohne} onChange={(e) => setOhne(e.target.checked)} /> Keinen Wartegrund setzen{bulk ? '' : ' (nur den Gf-AP-Termin absagen)'}
            </label>
            {!ohne && (
              <>
                <div className="reihe" style={{ gap: 12 }}>
                  <div className="feld" style={{ flex: 1 }}><label>Wartegrund</label>
                    <select value={hashtag} onChange={(e) => setHashtag(e.target.value)}>
                      <option value="">bitte wählen</option>
                      <GrundOptionen gruende={gruende} modus={liste} />
                    </select>
                  </div>
                  <div style={{ flex: 1 }}><WvHinweis fristen={info?.fristen} hashtag={hashtag} /></div>
                </div>
                <div className="feld">
                  <label>Kommentar für die Telekom <span className="rot">(Achtung: für die Telekom sichtbar, bitte in sauberen, vollständigen Sätzen)</span></label>
                  <textarea rows={3} value={kommentar} onChange={(e) => setKommentar(e.target.value)}
                            placeholder="z. B. Der Gf-AP-Termin wurde abgesagt, weil die Trasse bis zum Gebäude noch nicht durchgängig ist." />
                  {!kommentarOk && kommentar.trim() && <div className="klein rot">Bitte mindestens einen ganzen Satz schreiben.</div>}
                </div>
                <FreitextBausteine wert={kommentar} setze={(t) => setKommentar(/[.!?]$/.test(t) ? t : t + '.')}
                  vorschlaege={freitextVorschlaege(gewaehlt?.grund)} />
                {vorschau && (
                  <div className="hinweis" style={{ marginTop: 6 }}>
                    <div className="klein leise">So steht es im Portal:</div>
                    <div className="klein">{vorschau}</div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      <div className="reihe" style={{ marginTop: 10 }}>
        <button className="knopf haupt" disabled={laeuft || !bereit}
                onClick={() => fertig(grund.trim(), imGbgs ? (ohne ? { ohne: true } : { hashtag, kommentar: kommentar.trim(), wiedervorlage: wv || null }) : null)}>
          {laeuft ? 'Einen Moment' : 'Stornieren'}
        </button>
        <button className="knopf" onClick={zu} disabled={laeuft}>Abbrechen</button>
      </div>
    </Dialog>
  );
}
